import "./Loader.css";

const Loader = () => (
  <div className="loader-overlay">
    <svg width="90" height="82" viewBox="0 0 80 74" overflow="visible">
      <path
        className="heart-fill"
        d="M40 68 C40 68 4 46 4 22 C4 10 12 2 24 2 C31 2 37 6 40 11 C43 6 49 2 56 2 C68 2 76 10 76 22 C76 46 40 68 40 68Z"
        style={{ transformOrigin: "40px 36px" }}
      />
      <path
        className="heart-path"
        d="M40 68 C40 68 4 46 4 22 C4 10 12 2 24 2 C31 2 37 6 40 11 C43 6 49 2 56 2 C68 2 76 10 76 22 C76 46 40 68 40 68Z"
      />
    </svg>
  </div>
);

export default Loader;
